
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Log environment variables to help with debugging (without revealing sensitive data)
if (import.meta.env.DEV) {
  console.log('Running in development mode');
  console.log('Supabase URL configured:', !!import.meta.env.VITE_SUPABASE_URL);
  console.log('Supabase Anon Key configured:', !!import.meta.env.VITE_SUPABASE_ANON_KEY);
}

createRoot(document.getElementById("root")!).render(<App />);
